// =================================================================
// Unit conversion utilities (PSD §4.1 / TODO Task 1.32)
// Engine always receives conventional units; conversion at state boundary.
// =================================================================
import { UnitSystem, type PatientInput } from '@/types';

export const KG_TO_LB = 2.2046226;
export const CM_TO_IN = 0.3937008;
export const MGDL_TO_UMOLL = 88.4; // creatinine mg/dL → µmol/L

export function kgToLb(kg: number): number {
  return kg * KG_TO_LB;
}
export function lbToKg(lb: number): number {
  return lb / KG_TO_LB;
}
export function cmToIn(cm: number): number {
  return cm * CM_TO_IN;
}
export function inToCm(inch: number): number {
  return inch / CM_TO_IN;
}
export function mgDlToUmolL(mgdl: number): number {
  return mgdl * MGDL_TO_UMOLL;
}
export function umolLToMgDl(umol: number): number {
  return umol / MGDL_TO_UMOLL;
}

/**
 * Convert a PatientInput between unit systems.
 * Engine always receives conventional (kg, cm, mg/dL).
 */
export function convertPatientInput(
  patient: PatientInput,
  from: UnitSystem,
  to: UnitSystem,
): PatientInput {
  if (from === to) return patient;
  if (from === UnitSystem.SI && to === UnitSystem.Conventional) {
    return { ...patient, scrMgDl: umolLToMgDl(patient.scrMgDl) };
  }
  // Conventional → SI (display only; stored conventional)
  return { ...patient, scrMgDl: mgDlToUmolL(patient.scrMgDl) };
}

/** Format a number to a fixed precision for display. */
export function fmt(value: number | undefined | null, digits = 1): string {
  if (value == null || Number.isNaN(value)) return '—';
  return value.toFixed(digits);
}

/** Format a dose with rounding to whole mg. */
export function fmtDose(value: number | undefined | null): string {
  if (value == null || Number.isNaN(value)) return '—';
  return Math.round(value).toString();
}

/** Format a CrCl with 1 decimal. */
export function fmtCrCl(value: number | undefined | null): string {
  return fmt(value, 1);
}
